import React, {ReactNode} from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import './styles/main.scss';
import {QueryClientProvider} from '@tanstack/react-query';
import {PostHogProvider} from '@posthog/react';
import * as serviceWorker from './serviceWorker';
import {store} from './store/store';
import App from './App';
import {queryClient} from './utils/queryClient';
import {initPostHog, isPostHogEnabled, posthog} from './utils/posthog/posthog';

initPostHog('incase-editor');

const root = createRoot(document.getElementById('root') as HTMLElement);

function withPostHog(children: ReactNode): ReactNode {
    if (!isPostHogEnabled()) {
        return children;
    }

    return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}

root.render(
    withPostHog(
        <Provider store={store}>
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </Provider>
    )
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
